import React from 'react';
import clsx from 'clsx';
import styles from './Table.module.scss';

type Props = {
  htmlFor?: string;
  label?: string;
  className?: string;
  children: React.ReactNode;
};

const Table = React.forwardRef<HTMLTableElement, Props>((props, ref): JSX.Element => {
  const {
    className,
    children,
    ...other
  } = props;

  return (
    <table
      ref={ref}
      className={clsx(styles.root, className)}
      {...other}
    >
      {children}
    </table>
  );
});

export default React.memo(Table);
